import styled from 'styled-components';

export const MobileTabsContainer = styled.div`
  position: fixed;
  display: flex;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  border-radius: 50px;
  
  background-color: ${({ theme }) => theme.white};
  border: 1px solid #eeeeee;
  
  box-shadow: 0 5px 10px rgba(0, 0, 0, 0.2);
`;

export const MobileTab = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 7px 10px;
  
  font-weight: 700;
  font-size: 14px;
  line-height: 1;
  color: ${({ theme }) => theme.blue};

  svg {
    margin-right: 5px;
  }
`;

export const ModalDivider = styled.div`
  margin: 25px 0 25px;
  border: 0;
  border-bottom: 1px solid #f5f5f5;
`;

export const CheckboxList = styled.ul`
  li {
    display: flex;

    div {
      width: 100%;
      display: flex;

      label {
        width: 100%;
        justify-content: space-between;
      }
      span:nth-last-child(1){
          padding-right: 20px;
      }
    }
  }

  li:not(:last-child) {
    margin-bottom: 10px;
  }

  @media (max-height: 700px) {
    max-height: min(50vh, 320px);
    overflow-y: auto;
    overflow-x: hidden;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: thin;
    scrollbar-color: rgba(0, 0, 0, 0.2) transparent;
    padding-right: 4px;

    &::-webkit-scrollbar {
      width: 6px;
    }
    &::-webkit-scrollbar-track {
      background: transparent;
    }
    &::-webkit-scrollbar-thumb {
      background: rgba(0, 0, 0, 0.2);
      border-radius: 3px;
    }
    &::-webkit-scrollbar-thumb:hover {
      background: rgba(0, 0, 0, 0.3);
    }
  }
`;

export const FilterHeader = styled.h3`
  font-weight: normal;
  margin: 0;
  margin-bottom: 15px;
`;
